import styled from 'styled-components';
import ShowerSvg from '../../assets/amenities/shower.svg';

const ShowerIcon = styled(ShowerSvg as React.SFC<React.SVGProps<SVGSVGElement>>)`
  width: ${props => props.width || '2.4rem'};
  height: ${props => props.height || '2.4rem'};
  margin: ${props => props.margin};
`;

export default ShowerIcon;
